import type {
	BuildingSavingsDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { BUILDING_SAVINGS_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormDefaults";
import type { BuildingSavingsFormInput } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPortfolioToBuildingSavingsForm = (
	portfolio: PortfolioDetailResponseDTO,
): BuildingSavingsFormInput => {
	const data = portfolio.data as BuildingSavingsDetailDataDTO | undefined;
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		payment: data?.payment ?? DEFAULTS.payment,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
		appreciation: data?.appreciation ?? DEFAULTS.appreciation,
		stateContribution:
			typeof data?.stateContribution !== "boolean"
				? DEFAULTS.stateContribution
				: data.stateContribution
					? "Yes"
					: "No",
		targetAmount: data?.targetAmount ?? DEFAULTS.targetAmount,
	};
};
